
import { createSlice } from '@reduxjs/toolkit';
import { getAuthProps, setAuthProps, signOut } from '../../lib/authenticationLibrary';
import { saveData } from '../../utils/LocalStorage/LocalStorageManager';

const authData = getAuthProps();

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: (authData != null),
    user: (authData?.user), //Set user data from cookie.
    token: (authData?.token), //Set token data from cookie.
    authData,
    isLogedin: false
  },
  reducers: {
    authentication: (state, action) => {
      //Use to create cookie.
      // const { isAuthenticated, message, token, user, sessionTimeout, userDisplayName, userName, securityPermissions } = action.payload;

      const { message, securityPermissions, ...newAuthProps } = action.payload;

      const { isAuthenticated, user, roles } = action.payload;

      setAuthProps(newAuthProps);

      state.userPermissions = securityPermissions;
      state.isAuthenticated = isAuthenticated;
      state.roles = roles;
      state.user = user;

      state.isLogedin = true;

      saveData("SecurityPermission", securityPermissions);
    },
    logout: (state) => {
      state.isLogedin = false;
      signOut();
    },
  },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
